// extracted by mini-css-extract-plugin
export default {"btn":"ariya_btn__C4O4y"};